<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "ANTENATAL VISITS REPORT",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filtered_array: [],
      filterstatus: false,
      filterreport: {
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        age: "0",
        gender: "0",
        age_value: "",
        village: "",
      },
      title: "ANTENATAL VISITS REPORT",
      items: [
        {
          text: "FACILITY REPORTS",
          href: "#",
        },
        {
          text: "ANTENATAL  REPORT",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient_code",
          sortable: true,
          label: "CODE",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "visit_date",
          sortable: true,
          label: "VISIT DATE",
        },
        {
          key: "fundalHeight",
          sortable: true,
          label: "Fundal Height",
        },
        {
          key: "presentation",
          sortable: true,
          label: "Presentation",
        },

        {
          key: "FoetalHearRate",
          sortable: true,
          label: "Foetal Hear Rate",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "Added On",
        },
      ],
      data: {
        name: "",
        branch_id: "",
        type: "1",
        cost: "",
        price: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      costError: "",
      editData: {
        id: "",
        name: "",
        cost: "",
        price: "",
        branch_id: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
      //   ============================= EXPORT ==============================
      json_fields: {
        NAME: "patient_name",
        CODE: "patient_code",
        CONATCT: "patient_contact",
        GENDER: "gender",
        AGE: "age",
        VILLAGE: "village",
        SERVICES: "completetests",
        VISIT_DATE: "visitDate",
        TURN_AROUND_TIME: "turnardtime",
        PAY_RECORD: "payrecord",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters("reports", ["AntenatalVisitReport", "AntenatalReportStatus"]),
    ...mapGetters("patients", ["Villages"]),

    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },
  watch: {
    AntenatalVisitReport(newValue) {
      if (newValue.length > 0) {
        this.fill_antenatal_visit_report();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchAntenatalVisitReport: "reports/fetchAntenatalVisitReport",
    }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fill_antenatal_visit_report() {
      this.filtered_array = this.AntenatalVisitReport ? this.AntenatalVisitReport : [];
    },
    FilterRepo() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let gender = this.filterreport.gender;
      let age = this.filterreport.age;
      let age_value = this.filterreport.age_value;
      alert(age_value);
      if (
        startDate != "" &&
        endDate != "" &&
        gender != "0" &&
        age != "0" &&
        age_value != ""
      ) {
        this.filtered_array = this.AntenatalVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.gender_val == gender &&
            parseInt(pymts.age) + age + parseInt(age_value)
          );
        });
      } else if (startDate != "" && endDate != "" && gender == "0") {
        this.filtered_array = this.AntenatalVisitReport.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate;
        });
      } else if (startDate == "" && endDate != "") {
        this.filtered_array = this.AntenatalVisitReport.filter((pymts) => {
          return pymts.filter_date <= endDate;
        });
      } else {
        this.filtered_array = this.AntenatalVisitReports;
      }
    },
  },

  created() {
    this.FetchAntenatalVisitReport();

    this.fill_antenatal_visit_report();
  },
};
</script>

<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>

<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            {{ title }}<br />
            <div class="row">
              <div class="col-md-12">
                <div v-if="AntenatalReportStatus" class="loader-line"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>FROM</label>
                <input
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-6 form-group">
                <label>TO</label>
                <input
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="filtered_array"
                  :fields="json_fields"
                  :worksheet="'ANTENTAL VISITS REPORT ' + currentdate"
                  type="csv"
                  :name="'antenatalvisitsreport' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="filtered_array ? filtered_array : []"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
              <!-- <h3 v-if="!this.filtered_array" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3> -->
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
